import * as types from '../constants';

const initialState = {
  driverStanding: [],
  constructorStanding: [],
  driverStandings: {},
  constructorStandings: {},
};

export default function raceStandingsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_DRIVER_STANDINGS_SUCCESS:
      return {
        ...state,
        driverStandings: {
          ...state.driverStandings,
          [action.widgetId]: action.data,
        },
      };
    case types.GET_CONSTRUCTOR_STANDINGS_SUCCESS:
      return {
        ...state,
        constructorStandings: {
          ...state.constructorStandings,
          [action.widgetId]: action.data,
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/raceStandings.js